// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Pervasives from "../../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as PartnerLoginStatus from "../../../../app/partner/entity/PartnerLoginStatus.bs.js";
import * as FilterPartnerRequest from "../../../../app/filter-partners/entity/FilterPartnerRequest.bs.js";
import * as PartnerActiveStatusFilter from "../../../../app/filter-partners/entity/PartnerActiveStatusFilter.bs.js";

function appendRequestUrlParams(request) {
  return $$Array.fold_left((function (dict, param) {
                dict[param[0]] = param[1];
                return dict;
              }), {}, [
              [
                "geo_region_id",
                Belt_Option.mapWithDefault(request.geo_region_id, "", (function (prim) {
                        return String(prim);
                      }))
              ],
              [
                "vehicle_id",
                Belt_Option.mapWithDefault(request.vehicle_id, "", (function (prim) {
                        return String(prim);
                      }))
              ],
              [
                "engagement_type",
                Belt_Option.mapWithDefault(request.engagement_type, "", FilterPartnerRequest.getEngagementListToString)
              ],
              [
                "active_status",
                Belt_Option.mapWithDefault(request.active_status, "", PartnerActiveStatusFilter.to_string)
              ],
              [
                "availability",
                Belt_Option.mapWithDefault(request.availability, "", Pervasives.string_of_bool)
              ],
              [
                "gps_location",
                Belt_Option.mapWithDefault(request.gps_location, "", Pervasives.string_of_bool)
              ],
              [
                "status",
                Belt_Option.mapWithDefault(request.status, "", FilterPartnerRequest.getStatusListToString)
              ],
              [
                "login_status",
                Belt_Option.mapWithDefault(request.login_status, "", PartnerLoginStatus.toString)
              ],
              [
                "msisdn",
                Belt_Option.getWithDefault(request.msisdn, "")
              ],
              [
                "driver_name",
                Belt_Option.getWithDefault(request.driver_name, "")
              ],
              [
                "cluster_name",
                Belt_Option.getWithDefault(request.cluster_name, "")
              ],
              [
                "vehicle_number",
                Belt_Option.getWithDefault(request.vehicle_number, "")
              ]
            ]);
}

export {
  appendRequestUrlParams ,
  
}
/* No side effect */
